import { memo } from "react"
import DriverButton from "@/components/ui/driver-button"
import { useDriverButtonData } from "@/hooks/useDriverButtonData"

type DriverButtonContainerProps = {
  driverJid?: string
  chatJid?: string
  chatName?: string
  isSharedDriver: boolean
  isCoDriver: boolean
  onActiveChatChange: (chatJid: string) => void
}

const DriverButtonContainer = ({
  driverJid,
  chatJid,
  chatName,
  isSharedDriver,
  isCoDriver,
  onActiveChatChange,
}: DriverButtonContainerProps) => {
  const driverButtonData = useDriverButtonData(
    driverJid,
    isSharedDriver,
    onActiveChatChange,
    chatJid,
    chatName,
  )

  if (!driverButtonData) {
    return null
  }

  return (
    <DriverButton
      driver={driverButtonData.driver}
      avatarName={driverButtonData.avatarName}
      isCoDriver={isCoDriver}
      isSharedDriver={isSharedDriver}
      onClick={driverButtonData.onClick}
      chatName={driverButtonData.chatName}
      avatarColor={driverButtonData.avatarColor}
    />
  )
}

export default memo(DriverButtonContainer)
